import React, { Component } from 'react';
import {withStyles} from "@material-ui/core";
import {RouteHeader} from "../../components"

import {compose} from "redux"
import {withRouter,Route } from "react-router-dom";
import {firestoreConnect, isLoaded} from 'react-redux-firebase'
import { connect } from 'react-redux'
import _ from 'lodash';
import {surveyRoutes} from "../../routes"

class SurveyLayout extends Component {

    render() {
        const {  classes,match,...rest} = this.props;
        return (
            <div style={{backgroundColor:"white",height:"200vh"}} className={classes.root}>
                <RouteHeader history={this.props.history} title={this.props.survey&&this.props.survey.name?this.props.survey.name:"Untitled Campaign"}/>
                {_.map(surveyRoutes, (routes,key)=>{
                    const {path} = routes
                    const Component = routes.component
                    return (
                        <Route path={`${match.path}${path}`}
                               key={key}
                               render={ (route) =>
                                    <Component route={route} {...rest}/>
                               }
                        />
                    )
                })}
            </div>
            )
    }
}

const styles = {
    root: {
        flexGrow: 1
    }
}

export default compose(
    withStyles(styles),
    withRouter,
    firestoreConnect((props) =>{
        return props.match.params.id?[
        {
            collection: 'surveys',
            doc: props.match.params.id,
            storeAs: "survey"
        },
        { collection: 'surveys',
            doc: props.match.params.id,
            storeAs:"questions",
            subcollections:[{collection:"questions"}]
        },
        {
            collection: 'userAnswers',
            where: ['surveyId', '==', props.match.params.id],
            storeAs: "userAnswers"
        },
        {
            collection: 'users',
            storeAs: "users"
        },

    ]:[]}),
    connect((state) =>
    {
        return{
            survey: state.firestore.ordered.survey?state.firestore.ordered.survey[0]:null,
            questions:state.firestore.data.questions,
            userAnswers:state.firestore.ordered.userAnswers,
            users:state.firestore.data.users,
        }
    }),

)(SurveyLayout);



// WEBPACK FOOTER //
// ./src/layouts/Survey/SurveyLayout.jsx